<template>
  <div class="operations">

    <el-tooltip class="op-tooltip" effect="dark" content="Details" placement="top" :enterable="false">
      <button v-if="!disableMore" class="ui icon button more-btn"
        @click="$emit('view', id)">
        <i class="el-icon-more"></i>
      </button>
    </el-tooltip>

    <el-tooltip class="op-tooltip" effect="dark" content="Lights" placement="top" :enterable="false">
      <button v-if="showLights" class="ui icon button light-btn"
        @click="$emit('lights', id)">
        <i class="el-icon-fa-lightbulb-o"></i>
      </button>
    </el-tooltip>

    <br v-if="showLights">
      
    <el-tooltip class="op-tooltip" effect="dark" content="Edit" placement="top" :enterable="false">
      <button class="ui icon button edit-btn"
        @click="$emit('edit', id)">
        <i class="edit icon"></i>
      </button>
    </el-tooltip>

    <el-tooltip class="op-tooltip" effect="dark" content="Delete" placement="top" :enterable="false">
      <button class="ui icon button del-btn"
        @click="$emit('delete', id)">
        <i class="delete icon"></i>
      </button>
    </el-tooltip>

  </div>
</template>

<script>
export default {
  name: 'operations',
  props: ['id', 'disableMore', 'showLights'],
}
</script>



// WEBPACK FOOTER //
// OpButtons.vue?4df2f96d